import { DecodedParamsRoute } from 'components/routing/DecodedParamsRoute';
import React, { Suspense } from 'react';
import { makePath } from 'utils/routes';
import { Route, Router, Switch } from 'wouter';
import { LedgerProvider } from 'wrappers/LedgerProvider/LedgerProvider';
import { useWorkspace } from 'wrappers/WorkspaceProvider';

import { BreadcrumbComponent, BreadcrumbLoader } from './BreadcrumbUtils';
import { BreadcrumbIntegrations } from './IntegrationsBreadcrumb';
import { BreadcrumbLedgers } from './LedgersBreadcrumb';

export const Breadcrumb = () => {
  const { workspace } = useWorkspace();
  const workspaceId = workspace?.id;
  if (!workspaceId) {
    return <BreadcrumbComponent elements={[]} />;
  }

  const base = makePath(['w', workspaceId]);

  return (
    <Suspense fallback={<BreadcrumbLoader />}>
      <Router base={base} key={base}>
        <Switch>
          <DecodedParamsRoute path="/projects/schema/:schemaKey/ledgers">
            <BreadcrumbComponent elements={[{ name: 'Ledgers' }]} />
          </DecodedParamsRoute>
          <DecodedParamsRoute path="/projects/schema/:schemaKey/new-ledger">
            <BreadcrumbComponent elements={[{ name: 'Ledgers' }]} />
          </DecodedParamsRoute>
          <DecodedParamsRoute path="/projects/schema/:schemaKey">
            {({ schemaKey }) => (
              <BreadcrumbComponent
                elements={[
                  {
                    name: schemaKey,
                    url: makePath(
                      ['w', workspaceId, 'projects', 'schema', schemaKey],
                      {
                        absolute: true,
                      }
                    ),
                  },
                ]}
              />
            )}
          </DecodedParamsRoute>
          <DecodedParamsRoute path="/projects/schema/:schemaKey/scenario/:scenarioId">
            <BreadcrumbComponent elements={[]} />
          </DecodedParamsRoute>
          <DecodedParamsRoute path="/projects/schema/:schemaKey/:ledgerId/:rest*">
            {({ schemaKey, ledgerId }) => (
              <LedgerProvider params={{ ledgerId }} schemaKey={schemaKey}>
                <BreadcrumbLedgers
                  ledgerId={ledgerId}
                  schemaKey={schemaKey}
                  workspaceId={workspaceId}
                />
              </LedgerProvider>
            )}
          </DecodedParamsRoute>
          <DecodedParamsRoute path="/projects/:ledgerId/:rest*">
            {({ ledgerId }) => (
              <LedgerProvider params={{ ledgerId }}>
                <BreadcrumbLedgers
                  ledgerId={ledgerId}
                  workspaceId={workspaceId}
                />
              </LedgerProvider>
            )}
          </DecodedParamsRoute>
          <DecodedParamsRoute path="/projects">
            <BreadcrumbComponent
              elements={[
                {
                  name: 'Projects',
                  url: makePath(['w', workspaceId, 'projects'], {
                    absolute: true,
                  }),
                },
              ]}
            />
          </DecodedParamsRoute>
          <DecodedParamsRoute path="/integrations/:rest*">
            <BreadcrumbIntegrations workspaceId={workspaceId} />
          </DecodedParamsRoute>
          <Route>
            <BreadcrumbComponent elements={[]} />
          </Route>
        </Switch>
      </Router>
    </Suspense>
  );
};
